import { GetCache } from './usecases/get-cache'

export class GetLocalStorage implements GetCache {
  get(key: string): string | number | object {
    const item = window.localStorage.getItem(key)

    return item && JSON.parse(JSON.stringify(item))
  }
}
